import axios from 'axios'
import { message } from 'ant-design-vue'
import GLOBAL from '@/components/common/Global'
import crypto from 'crypto'
import XEUtils from 'xe-utils'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_URL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  },
  timeout: 300000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    console.log('', config.headers['Content-Type'])
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json;charset=utf-8'
    }
    // do something before request is sent
    // console.log('store.getters.token:', store.getters.token)
    // if (store.getters.token) {
    let token = GLOBAL.getToken()
    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['Authorization'] = token

      config.headers['token'] = token
      config.headers['Authorization'] = token
      // 园区综合治理登录 token （调用园区综合治理接口使用）
      config.headers['keycloakToken'] = token
      const date = XEUtils.timestamp()
      const md5 = crypto.createHash('md5')
      md5.update('Khaos-hc-2020%^$*&#' + date + '/' + config.url)
      config.headers['sign'] = md5.digest('hex').toUpperCase()
      config.headers['invokeTime'] = date
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    if(res.code == 0 ){
      return res
    }
    if(res.status == 0 ){
      return res
    }
    if(response.status == 200 && !res.code) {
      return res
    }
    // if the custom code is not 20000, it is judged as an error.
    if (res.code != 200) {
      if(res.message == '当前用户无权限') {
        return res.data
      }else {
        message.error(res.message || 'Error', 5)
        return Promise.reject(new Error(res.message || 'Error'))
      }
    } else {
      return res.data
    }
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '数据存在错误或输入内容格式不正确，请联系管理员确认'
          break

        case 401:
          localStorage.removeItem('token')
          localStorage.removeItem('refreshToken')
          localStorage.removeItem('userInfo')
          GLOBAL.goUrl(process.env.BASE_URL,'index.html');
          break

        case 403:
          err.message = '拒绝访问'
          break

        case 404:
          err.message = `请求地址出错: ${err.response.config.url}`
          break

        case 408:
          err.message = '请求超时'
          break

        case 500:
          err.message = '服务器内部错误'
          break

        case 501:
          err.message = '服务未实现'
          break

        case 502:
          err.message = '网关错误'
          break

        case 503:
          err.message = '服务不可用'
          break

        case 504:
          err.message = '网关超时'
          break

        case 505:
          err.message = 'HTTP版本不受支持'
          break
      }
    }
    message.warning(err.message, 5)
    return Promise.reject(err)
  }
)

export default service
